import React from "react";

export const Logo = ({ className = "", light = false }) => {
  const roof = "#C59B27";
  const body = light ? "#FFFFFF" : "#0A5C80";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="nav-brand-logo">
      <svg width="38" height="38" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path d="M24 4L44 18V20H4V18L24 4Z" fill={roof} />
        <rect x="8" y="20" width="32" height="24" rx="2" fill={body} />
        <path d="M8 30H40" stroke={roof} strokeWidth="2.4" />
        <path d="M24 20V44" stroke={roof} strokeWidth="2.4" />
        <rect x="20" y="24" width="8" height="4" rx="1" fill={roof} />
      </svg>
      <div className="leading-none">
        <div className={`font-serif text-lg font-semibold tracking-tight ${light ? "text-white" : "text-brand-navy"}`}>
          Pack 2 Perfection
        </div>
        <div className={`text-[10px] uppercase tracking-[0.18em] ${light ? "text-white/70" : "text-brand-gold"}`}>
          Pensacola • Emerald Coast
        </div>
      </div>
    </div>
  );
};
